import { Badge, HorizontalStack, LegacyCard, LegacyStack, Text } from '@shopify/polaris';

const InventoryNumbers = ({ inventory }) => {
  return (
    <LegacyCard>
      <LegacyCard.Section>
        <LegacyStack distribution="fill">
          <span>
            <Text variant="headingXs" weight="semibold">
              Uds.
            </Text>
            <Text variant="heading3xl">{inventory.stockQtyFound}</Text>
            <Text variant="headingSm" fontWeight="light">
              {inventory.stockQtyExpected > 0 ? inventory.stockQtyExpected : 0} esperados (Dif:{' '}
              {inventory.stockQtyFound - inventory.stockQtyExpected} uds)
            </Text>
          </span>
          <span>
            <Text variant="headingXs" weight="semibold">
              Serie-Color
            </Text>
            <Text variant="heading3xl">{inventory.distinctProducts}</Text>
            <Text variant="headingSm" fontWeight="light">
              {inventory.distinctProductsExpected > 0 ? inventory.distinctProductsExpected : 0} esperados
            </Text>
          </span>
        </LegacyStack>
      </LegacyCard.Section>
      <LegacyCard.Section>
        <LegacyStack distribution="" alignment="center">
          {inventory.partialSeries && (
            <Badge size="small" progress="partiallyComplete" status="warning">
              Inventario por Series
            </Badge>
          )}
          {!inventory.partialSeries && inventory.partial && (
            <Badge size="small" progress="partiallyComplete" status="attention">
              Inventario por Taxonomias
            </Badge>
          )}
          {!inventory.partialSeries && !inventory.partial && (
            <Badge size="small" progress="complete">
              Inventario Completo
            </Badge>
          )}
          {inventory.partial && (
            <HorizontalStack>
              <Text variant="headingXs" weight="semibold">
                Filtros:
              </Text>
              <span style={{ display: 'flex', justifyContent: 'center' }}>
                <Text variant="headingXs" weight="semibold">
                  {Object.keys(inventory.partialParams)
                    .filter((k) => inventory.partialParams[k] !== null)
                    .map((k) => inventory.partialParams[k].join(' | '))
                    .join(' - ')}
                </Text>
              </span>
            </HorizontalStack>
          )}
        </LegacyStack>
      </LegacyCard.Section>
    </LegacyCard>
  );
};

export default InventoryNumbers;
